import { LANGUAGE_CODE } from '../constant/language';
import { filterEmptyContent, isNullOrUndefinedOrEmpty } from './stringHelper';

const formatStringToCamelCase = (str: string) => {
  const splitted: string[] = str.split('-');
  if (splitted.length === 1) return splitted[0];
  return (
    splitted[0] +
    splitted
      .slice(1)
      .map(word => word[0].toUpperCase() + word.slice(1))
      .join('')
  );
};

export const getStyleObjectFromString = (
  str: string
): {
  [key: string]: string | undefined;
} => {
  const style = {};
  try {
    if (!isNullOrUndefinedOrEmpty(str)) {
      str.split(';').forEach(el => {
        const [property, value] = el.split(':');
        if (!property) return;

        const formattedProperty = formatStringToCamelCase(filterEmptyContent(property, '').trim());
        style[formattedProperty] = filterEmptyContent(value, '').trim();
      });
    }
  } catch (e) {
    console.log(e);
  }

  return style;
};

export const getDirection = (languageCode: string): string => {
  if (languageCode === LANGUAGE_CODE.ARABIC || languageCode === LANGUAGE_CODE.HEBREW) {
    return 'rtl';
  } else {
    return 'ltr';
  }
};

export const getStyle = (e): any => {
  return window.getComputedStyle ? window.getComputedStyle(e, null) : e.currentStyle;
};
